<template>
  <div>
    <ScrollView
      class="DashScrollContainer"
      :refreshing="refreshing"
      @onRefresh="onRefresh"
      :empty="data.length === 0"
    >
      <CDataTable
        striped
        hover
        bordered
        small
        fixed
        :items="rowData"
        :fields="fields"
        :items-per-page="Number(50)"
        :noItemsView="noItems"
        style="flex: 1"
      >
        <template v-for="(cel, i) of fields" #[cel.key]="{item}">
          <td :style="item.style" :key="cel.key" @click="clickRow(item)">
            <i v-if="i===0 && item.children" class="fa" :class="`fa-chevron-${item.open ? 'up' : 'down'}`"></i>
            {{ item[cel.key] }}
          </td>
        </template>
      </CDataTable>
      <template slot="Empty">
        <slot name="Empty" />
      </template>
    </ScrollView>
  </div>
</template>

<script>
import { makeCSS, formaters } from "./utils";
export default {
  name: "CollapseTable",
  components: {},
  props: {
    refreshing: {
      type: Boolean,
      default: false
    },
    onRefresh: {
      type: Function,
      default: () => {}
    },
    data: {
      type: Array,
      default: () => []
    },
    estructura: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      collapse: [],
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" }
    };
  },
  computed: {
    fields() {
      return this.estructura.map(m => ({
        key: m.expresion,
        label: m.etiqueta,
        _style: this.makeCSS(m)
      }));
    },
    rowData() {
      return this.items.reduce((v, c, indx) => {
        console.log(c.children);
        v.push({
          key: `${indx}`,
          ...c,
          open: this.collapse.includes(`${indx}`)
        });
        if (this.collapse.includes(`${indx}`)) {
          v.push(
            ...c.children.map((m, i) => ({
              isChildren: true,
              key: `${indx}-${i}`,
              ...m
            }))
          );
        }
        return v;
      }, []);
    },
    items() {
      return this.data.map(m => {
        const style = this.makeCSS(m);
        const row = { style, children: m.children };
        this.estructura.forEach(item => {

          const value = m =>
            m[item.expresion]
              ? `${this.formaters(item)(m[item.expresion], item?.style)}${
                  item?.style?.sufijo ? ` ${item?.style?.sufijo}` : ""
                }`
              : " ";
          row[item.expresion] = value(m);
        });
        return row;
      });
    }
  },
  methods: {
    formaters(item){
      return formaters(item?.style?.tipo)
    },
    clickRow(item){
        debugger
        return item.children?.length ? this.handleToggle(item.key.split('-')[0]) : null
    },
    handleToggle(itm) {
        debugger
      const list = this.collapse;
      this.setCollapse(
        list.includes(itm) ? list.filter(ff => ff !== itm) : [...list, itm]
      );
    },
    setCollapse(collapse) {
      this.collapse = collapse;
    },
    makeCSS(v) {
      return makeCSS(v);
    }
  }
};
</script>

<style lang="scss" scoped>
.DashScrollContainer {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-evenly;
}
</style>
